


  ;(function($){

    function Menu()
    {
        $(".btn-open").click(function(){
            $(".nav-menu").addClass("open");
        });
        $(".btn-open").click(function(){
            $(".nav-menu").removeClass("close");
        });
        
        $(".btn-close").click(function(){
            $(".nav-menu").addClass("close");
        });
        $(".btn-close").click(function(){
            $(".nav-menu").removeClass("open");
        });
    }

   	new Menu();

}(jQuery));